<template>
  <div class="checkboxes-input">
    <div class="form-group row">
      <label :class="options.fullWidth ? 'col-sm-12' : 'col-sm-4 col-form-label'">
        {{ options.label }}
        <span v-if="options.required" class="required">*</span>
      </label>
      <div :class="options.fullWidth ? 'col-sm-12' : 'col-sm-8'">
        <template v-for="object in options.objects">
          <div class="mb-2" :key="object.uuid">
            <div class="checkbox d-flex align-items-center">
              <label class="mb-0 switch fas fa-2x" :class="{ 'fa-toggle-on text-success': value.includes(object.uuid), 'fa-toggle-on fa-flip-horizontal text-muted': !value.includes(object.uuid) }">
                <input type="checkbox"
                  :id="options.name"
                  :value="object.uuid"
                  :checked="value.includes(object.uuid)"
                  :name="options.name + '[]'"
                  @change="validate($event)"/>
                <span class="slider round"></span>
              </label>
              <span class="ml-2 font-weight-bold">{{ object[options.objectName] }}</span>
            </div>
            <div v-html="object.description"></div>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import {
  validationClass,
  validationIcon,
  validationMessage
} from '@/util/helpers'

export default {
  name: 'CheckboxesInput',
  props: {
    value: {
      type: Array
    },
    options: {
      type: Object,
      default () {
        return {
          label: '',
          name: '',
          required: false
        }
      }
    }
  },
  data () {
    return {
      isValid: true
    }
  },
  computed: {
    validationClass,
    validationIcon,
    validationMessage
  },
  methods: {
    validate (event = false) {
      let value = this.value
      if (event) {
        if (value.includes(event.target.value)) {
          value = value.filter((el) => event.target.value !== el)
        } else {
          value = [ ...value, event.target.value ]
        }
      }
      this.$emit('input', value)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/inputs/CheckboxesInput.vue